import { CobranzaDetalle } from './../../../models/CobranzaDetalle';
import { Component} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessagesTitles, MessagesGeneral, MessagesDates,MessagesStatus } from '../../../models/messages';
import * as moment from 'moment';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import {HttpErrorResponse } from '@angular/common/http';
import { DatePipe,Location,DecimalPipe } from '@angular/common';
import { MomentDateAdapter } from "@angular/material-moment-adapter";

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";

import Swal from "sweetalert2";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-nuevo-cobranza',
  templateUrl: './nuevo-cobranza.component.html',
  styleUrls: ['./nuevo-cobranza.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,MessagesStatus,
    DatePipe,
    DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class NuevoCobranzaComponent {

  maxDate = moment();
  varAbrirCobranzaDetalle : boolean = false;
  cuentaFilter:any =[];
  TipoPago :any = [];
  formCabeceraCobranza: FormGroup;
  CobranzaDetalle : CobranzaDetalle[] = [];
  loading : boolean = false;
  user : any;
  disableSelect:boolean=false;
  arrayCuentaBancaria:any=[];
  CobranzaTemporal: any = {}
  Cobranza:any=[];
  total:any = 0;

  constructor(private location: Location,
    private datepipe :DatePipe,
    private CobranzaService:CobranzasService,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus) {
      
    let now = moment();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.formCabeceraCobranza = new FormGroup({
      frmFechaCabecera : new FormControl(now),
      frmMoneda : new FormControl(''),
      frmCuentaBancaria : new FormControl('',[Validators.required]),
      frmBanco : new FormControl(''),   
    });
  }

  

  tipoMoneda(event){
    this.CobranzaTemporal.Moneda = event;
    this.formCabeceraCobranza.controls['frmMoneda'].setValue(event);
    this.cuentasFilter();
   }
   entidadF(event){
    this.CobranzaTemporal.Banco = event;
    this.formCabeceraCobranza.controls['frmBanco'].setValue(event);
    this.cuentasFilter();
   }
   arrayCuenta(event){
    this.arrayCuentaBancaria = Array.isArray(event) ? event : [];
    this.cuentasFilter();
   }   

  agregarCobranzaDetalle(){
    this.varAbrirCobranzaDetalle = true;
  }

  RecibirCabeceraDetalle(event){
    this.CobranzaDetalle.push(event);  
    this.total = 0;
    this.CobranzaDetalle.forEach(e => {
      this.total+=Number(e.Deposito_a_Aplicar)
    }); 
    console.log('push',this.CobranzaDetalle); 
    console.log('total',this.total);
    
    this.varAbrirCobranzaDetalle = false;
    this.disableSelect = true;    
    console.log('1',this.CobranzaDetalle);
  }

  MetCerrarCobranzaDetalle(){
    this.varAbrirCobranzaDetalle = false; 
  }

  guardarCobranza(){
    this.CobranzaTemporal.CobranzaDetalle = [];
    console.log('2',this.CobranzaDetalle);
    for (const item of this.CobranzaDetalle) {
      this.CobranzaTemporal.CobranzaDetalle.push(item)
    }
    
    this.CobranzaTemporal.CobranzaDetalle.forEach(item => {
      item.Fecha_Pago = item.Fecha;
      item.Fecha = this.datepipe.transform(this.formCabeceraCobranza.controls['frmFechaCabecera'].value,'yyyyMMdd');     
      item.Alta_Fecha = this.datepipe.transform(Date(),"yyyy-MM-dd");
      item.Alta_Usuario = this.user.Usuario;
      item.Cuenta = this.formCabeceraCobranza.controls["frmCuentaBancaria"].value;
      item.Estado = "P";
      item.Moneda = this.CobranzaTemporal.Moneda;
      item.Banco = this.CobranzaTemporal.Banco;
    });
   
    Swal.fire({
      title: "Espere...",
      text: "Guardando la información.",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();
    this.CobranzaService.CrearCobranza(this.CobranzaTemporal)
    .subscribe(res => {
    Swal.fire({
      title: "¡Éxito!",
      text: "Cobranza registrada correctamente",
      type: "success",
      allowOutsideClick: false,
      heightAuto: false
    }).then(resp => {
      if (resp.value == true) {
        this.goBack();
      }
    });
    },(err: HttpErrorResponse)=> {
        this.msgStatus.getMessage(err.status);
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "COBRANZA NO REGISTRADA. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    });

  }

  goBack() {
    this.location.back();
  }

  cuentasFilter(){
    this.formCabeceraCobranza.controls['frmCuentaBancaria'].setValue('');
    const moneda = String(this.CobranzaTemporal.Moneda != null ? this.CobranzaTemporal.Moneda : '');
    const banco = String(this.CobranzaTemporal.Banco != null ? this.CobranzaTemporal.Banco : '');
    if (!moneda || !banco) {
      this.cuentaFilter = [];
      return;
    }
    this.cuentaFilter = (this.arrayCuentaBancaria || []).filter(
      cta => String(cta.idGuiaMoneda) === moneda && String(cta.idGuiaBanco) === banco
    );
  }

  eliminarItem(i : number, Deposito_a_Aplicar){
    this.CobranzaDetalle.splice(i,1);
    this.total = this.total -Number(Deposito_a_Aplicar)
    if(this.CobranzaDetalle.length == 0){
      this.disableSelect = false;
    }
  }

}

